// Resolves the impure inputs to navDestinations — feature flags + the PdM
// entitlement — in one place so the sidebar and the mobile tab bar agree on
// which destinations exist. The ordering/policy lives in the pure
// view-models/navDestinations selector; this only gathers the gates.

import { useAuthStore } from '@/store/authStore';
import { evaluateFlag } from '@/featureFlags';
import { usePdmEntitlement } from '@/view-models/pdmHealth';
import type { NavGates } from '@/view-models/navDestinations';

export function useNavGates(): NavGates {
  const user = useAuthStore((s) => s.user);
  const overrides = useAuthStore((s) => s.flagOverrides);

  const ctx = {
    email: user?.email ?? null,
    roles: user?.roles ?? [],
    isAuthed: user != null,
    flagOverrides: overrides,
  };

  const alertsEnabled = evaluateFlag('alerts-page', ctx);

  // PdM needs BOTH the per-user flag AND the company's subscription. The
  // entitlement endpoint 404s without the flag server-side, so the query only
  // runs (and can succeed) for flagged users.
  const pdmFlag = evaluateFlag('pdm-page', ctx);
  const pdm = usePdmEntitlement(pdmFlag);

  return {
    alertsEnabled,
    pdmEnabled: pdmFlag && !!pdm.data?.enabled,
  };
}
